import React from "react";

import "./styles.css";

const Loader = ({ className }) => <div className={`loader ${className}`}>Loading...</div>;

export default Loader;
